<script setup lang="ts"></script>

<template>
  <div
    class="container main w-full sm:w-[640px] md:w-[768px] lg:w-[1024px] xl:w-[1280px] 2xl:w-[1536px] sm:min-h-[800px] sm:h-auto"
  >
    <!-- Fixed Top -->
    <div class="header-fixed w-full">
      <slot name="top" />
    </div>

    <!-- Fixed Header -->
    <div class="header-fixed w-full">
      <slot name="header" />
    </div>

    <!-- Fixed Filters -->
    <div class="filters-fixed w-full">
      <slot name="filters" />
    </div>

    <!-- Main Content Area -->
    <div class="body-content w-full">
      <div class="content">
        <slot name="body" />
      </div>
    </div>

    <!-- Fixed Footer -->
    <div class="footer-fixed w-full">
      <slot name="footer" />
    </div>
  </div>
</template>

<style scoped>
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(var(--vh, 1svh) * 100 - env(safe-area-inset-top));
  box-sizing: border-box;
}

/* Fixed Header */
.header-fixed {
  position: relative;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: white;
}

/* Fixed Filters */
.filters-fixed {
  position: relative;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* width: 100%; */
  /* max-width: 1024px; */
  z-index: 90;
  background: white;
  padding-left: 8px;
  padding-right: 8px;
}

/* Main Content Area */
.body-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content {
  flex: 1;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  padding-left: 8px;
  padding-right: 8px;
}

.content::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* Fixed Footer */
.footer-fixed {
  position: relative;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  /* max-width: 1024px; */
  z-index: 100;
  background: white;
  padding-left: 8px;
  padding-right: 8px;
}

/* Mobile-specific styles */
@media (max-width: 640px) {
  .header-fixed,
  .filters-fixed,
  .footer-fixed {
    max-width: 100%;
  }
}
</style>
